import { StudentAdditionalNote } from '@modules/types/graphql';

export const additionalNoteTranslates = {
    [StudentAdditionalNote.empty]: 'students:blocks.additional_note.empty',
    [StudentAdditionalNote.registerPolice]: 'students:blocks.additional_note.register_police',
    [StudentAdditionalNote.registerSchool]: 'students:blocks.additional_note.register_school',
};

export const additionalNoteEntries = Object.entries(additionalNoteTranslates);
